import React, { Component } from "react";
import { Form, Input, Select, Button, message, DatePicker, Progress, Tooltip, Checkbox } from "antd";
import moment from "moment";
import {
  getTypicalCasesBaseInfo,
  getTypicalCasesList,
  getPatientSourceList,
  getConsultationApplyHospital,
  getProvinceData,
} from "@/request/api";
import { refreshTime, requestErrorLog } from "@/common/util";
const { Option } = Select;

class ConstQueryTable extends Component {
  constructor(props) {
    const settingData = JSON.parse(localStorage.getItem("settingValues"));
    super(props);
    this.state = {
      reportStatus: [],
      departmentList: [],
      consultationStatus: [],
      source: [],
      tableData: [], // 列表数据
      percent: 0,
      searchObj: {
        type: "",
        queryData: "ECG",
      },
      RowCount: 0,
      PageNo: 1,
      PageSize: 10,
      refreshTimeNum: 0,
      // 开始日期-结束日期
      defaultSelectDate: {
        startDate: moment()
          .startOf("day")
          .subtract(settingData && settingData.consulation - 1, "days"),
        endDate: moment().endOf(-1, "day"),
      },
      tableKeys: this.props.data,
      applyHospitalList: [],
      criticalIsTop: 0
    };
  }

  async componentDidMount() {
    let res = await getProvinceData()
    //将省份信息存一个哈希map，用来做字典查询
    let hashMapProvince = res.Result ? res.Result : []
    hashMapProvince = new Map(hashMapProvince.map(item => [item.PROVINCE_CODE, item.PROVINCE_NAME]))

    this.setState({
      hashMapProvince,
    }, () => {
      this.allBasicData();
      this.consultQueryList();
      this.initApplyHostpitalList();
      this.props.onRef(this);
      let refreshTimeNum = refreshTime(this);
      this.setState(
        {
          refreshTimeNum,
        },
        () => {
          this.refreshTimer = setInterval(
            () => refreshTime(this, this.consultQueryList),
            (this.state.refreshTimeNum * 1000 * 60) / 200
          );
        }
      );
    })
  }

  // getProvinceData = async () => {
  // }
  componentWillUnmount() {
    clearInterval(this.refreshTimer);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data !== this.props.data && nextProps.data !== nextState.tableKeys) {
      this.setState(
        {
          tableKeys: nextProps.data,
          PageSize: 10,
          PageNo: 1,
        },
        () => {
          this.consultQueryList(nextProps.data);
        }
      );
    }
    if (nextProps.PageNo !== this.props.PageNo || nextProps.PageSize !== this.props.PageSize) {
      this.setState(
        {
          PageNo: nextProps.PageNo,
          PageSize: nextProps.PageSize,
        },
        () => {
          this.consultQueryList(this.state.tableKeys);
        }
      );
    }
    return true;
  }

  allBasicData = () => {
    //患者来源
    let params = { pageNo: 1, pageSize: 10, NAME: "" };
    getPatientSourceList(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          source: res.Result.dataList,
        });
      } else {
        requestErrorLog("", "远程会诊查询来源列表接口报错", 0, true);
      }
    });
    getTypicalCasesBaseInfo().then((res) => {
      if (res && res.Status === 1) {
        const basicsdata = res.Result.basicsdata;
        const department = res.Result.department;
        for (var i = 0; i < basicsdata.length; i++) {
          if (basicsdata[i].name === "状态") {
            const reportStatus = basicsdata[i].dt;
            this.setState({
              reportStatus: reportStatus,
            });
          }
          if (basicsdata[i].name === "会诊状态") {
            const status = basicsdata[i].dt;
            this.setState({
              consultationStatus: status,
            });
          }
        }
        for (var s = 0; s < department.length; s++) {
          const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
          if (userInfo.HOSPITAL_NAME === department[s].name) {
            const departmentList = department[s].dept;
            this.setState({
              departmentList: departmentList,
            });
          }
        }
      } else {
        requestErrorLog("", "远程会诊查询基础数据口报错", 0, true);
      }
    });
  };

  consultQueryList = (tableKeys) => {
    const { searchObj } = this.state;
    let tabskeyws = this.state.tableKeys.toString();
    switch (parseInt(tableKeys) || parseInt(tabskeyws)) {
      case 1:
        searchObj.type = "CONSULTATIONData";
        searchObj.queryData = "ECG";
        break;

      case 2:
        searchObj.type = "CONSULTATIONData";
        searchObj.queryData = "Holter";
        break;

      case 3:
        searchObj.type = "CONSULTATIONData";
        searchObj.queryData = "BloodPressure";
        break;

      case 4:
        searchObj.type = "PersonalData";
        searchObj.queryData = "ECG";
        break;

      case 5:
        searchObj.type = "PersonalData";
        searchObj.queryData = "Holter";
        break;
      case 6:
        searchObj.type = "PersonalData";
        searchObj.queryData = "BloodPressure";
        break;

      default:
        searchObj.type = "CONSULTATIONData";
        searchObj.queryData = "ECG";
        break;
    }
    this.handleHospitalSubmit(searchObj);
  };
  searchListFn = () => {
    this.setState(
      {
        PageNo: 1,
        PageSize: 10,
      },
      () => {
        this.consultQueryList();
      }
    );
  };
  handleHospitalSubmit = (searchObj) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.startTime > values.endTime) {
          message.error("开始时间不得大于结束时间");
          return;
        }
        let params = {
          Type: searchObj.type, // 查询
          hospital_Code: userInfo.HOSPITAL_CODE,
          exam_class: searchObj.queryData, // 静息心电、动态心电、动态血压
          user_uid: userInfo.USER_UID,
          CONSULTATION_STATUS: values.CONSULTATION_STATUS, //会诊状态
          hospitalDoctor: values.hospitalDoctor || "",
          hospitalItemDoctor: values.hospitalItemDoctor || "",
          hospitalPatientName: values.hospitalPatientName || "",
          hospitalReportStatus: values.hospitalReportStatus || "",
          hospitalNumber: values.hospitalNumber || "病历号",
          hospitalItemNumber: values.hospitalItemNumber || "",
          hospitalApply: values.hospitalApply || "",
          hospitalItemApply: values.hospitalItemApply || "",
          hospitalApplyDepartment: values.hospitalApplyDepartment || "",
          hospitalPatientSource: values.hospitalPatientSource || "",
          hospitalDateTime: values.hospitalDateTime || "",
          hospitalConclusion: values.hospitalConclusion || "", //检查结论
          hospitalItemDateTime: [
            moment(values.startTime).format("YYYY-MM-DD"),
            moment(values.endTime).format("YYYY-MM-DD"),
          ],
          PageNo: this.state.PageNo,
          PageSize: this.state.PageSize,
          IS_TOP: this.state.criticalIsTop, // 0不勾选 1勾选
        };
        getTypicalCasesList(params).then((res) => {
          if (res && res.Status === 1) {
            let data = res.Result;
            data.forEach(item => {
              if (this.state.hashMapProvince.has(item.FIRST_GROUP_CODE)) {
                item.PROVINCE = this.state.hashMapProvince.get(item.FIRST_GROUP_CODE)
              }
            });
            let RowCount = res.ResponseModel.RowCount;
            this.setState({
              tableData: data,
              RowCount: RowCount,
            });
            this.props.getData(data, RowCount, this.state.PageNo, this.state.PageSize);
            delete params.PageNo;
            delete params.PageSize;
            this.consultCount(params);
            this.workbenchCount(params);
            this.props.getMessageFn();
          } else {
            requestErrorLog("", "远程会诊列表接口报错", 0, true);
            message.error("请检查网络连接");
          }
        });
      }
    });
  };

  //申请医院列表
  initApplyHostpitalList = () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let code = userInfo.HOSPITAL_CODE;
    getConsultationApplyHospital(code).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          applyHospitalList: res.Result,
        });
      } else {
        requestErrorLog("", "远程会诊查询申请医院列表接口报错", 0, true);
      }
    });
  };

  // 切换申请医院跟申请科室时
  handleHospDeptValue = (value) => {
    this.setState({
      hospitalDeptValue: value,
    });
  };

  consultCount = (params) => {
    //公共池未读消息
    params.Type = "CONSULTATIONDataCount";
    getTypicalCasesList(params).then((res) => {
      if (res && res.Status === 1) {
        const count = res.Result;
        this.props.setConsultCount(count);
      } else {
        requestErrorLog("", "远程会诊公共池未读消息接口报错", 0, true);
        message.error("请检查网络连接");
      }
    });
  };

  workbenchCount = (params) => {
    //个人工作台未读消息
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    params.Type = "PersonalDataCount";
    params.doctor_name = userInfo.REAL_NAME;
    getTypicalCasesList(params).then((res) => {
      if (res && res.Status === 1) {
        const count = res.Result;
        this.props.setWorkbenchCount(count);
      } else {
        requestErrorLog("", "远程会诊个人工作台未读消息接口报错", 0, true);
        message.error("请检查网络连接");
      }
    });
  };

  handleChangeReset = () => {
    this.props.form.resetFields();
    this.setState({
      criticalIsTop: 0
    })
  };

  onCriticalChange = (event) => {
    this.setState({
      criticalIsTop: event.target.checked ? 1 : 0
    });
  }

  // 只能选择今天跟今天之前的日期
  disabledDate(current) {
    return current > moment().subtract(0, "day");
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      reportStatus,
      departmentList,
      consultationStatus,
      source,
      percent,
      defaultSelectDate: { startDate, endDate },
      applyHospitalList,
    } = this.state;
    const settingData = JSON.parse(localStorage.getItem("settingValues"));
    return (
      <>
        <Form layout="inline" className="commonCase">
          <div>
            <Form.Item label="患者姓名">
              {getFieldDecorator("hospitalPatientName", { initialValue: "" })(<Input />)}
            </Form.Item>

            <Form.Item label="报告状态">
              {getFieldDecorator("hospitalReportStatus", { initialValue: "" })(
                <Select>
                  <Option value="">全部</Option>
                  {reportStatus.map((item) =>
                    item.DIC_NAME !== "未检查" && item.DIC_NAME !== "已退回" ? (
                      <Option key={item.DIC_CODE} value={item.DIC_CODE}>
                        {item.DIC_NAME}
                      </Option>
                    ) : null
                  )}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="会诊状态">
              {getFieldDecorator("CONSULTATION_STATUS", { initialValue: "" })(
                <Select>
                  <Option value="">全部</Option>
                  {consultationStatus.map((item) => (
                    <Option key={item.DIC_CODE} value={item.DIC_CODE}>
                      {item.DIC_NAME}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item
              className="specialNumber mark hosp"
              style={{ width: 277 }}
              label={getFieldDecorator("hospitalNumber", {
                initialValue: (settingData && settingData.hospitalNumber) || "病历号",
              })(
                <Select style={{ width: 126 }}>
                  <Option value="病历号">病历号：</Option>
                  <Option value="住院号">住院号：</Option>
                  <Option value="门诊号">门诊号：</Option>
                  <Option value="申请号">申请号：</Option>
                </Select>
              )}
            >
              {getFieldDecorator("hospitalItemNumber", { initialValue: "" })(<Input />)}
            </Form.Item>
            <Form.Item label="检查结论" className="conclusion">
              {getFieldDecorator("hospitalConclusion", { initialValue: "" })(<Input style={{ width: 197 }} />)}
            </Form.Item>
            <div className="checkedCritical consult">
              <p>危急病例置顶：</p>
              <Checkbox onChange={this.onCriticalChange} checked={this.state.criticalIsTop}></Checkbox>
            </div>
          </div>
          <div>
            <Form.Item label="患者来源">
              {getFieldDecorator("hospitalPatientSource", { initialValue: "" })(
                <Select>
                  <Option value="">全部</Option>
                  {source.map((item) => (
                    <Option key={item.PATIENT_SOURCE_CODE} value={item.PATIENT_SOURCE_CODE}>
                      {item.PATIENT_SOURCE_NAME}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item
              className="mark hosp"
              style={{ width: 436 }}
              label={getFieldDecorator("hospitalItemApply", { initialValue: "申请医院" })(
                <Select onChange={this.handleHospDeptValue}>
                  <Option value="申请医院">申请医院：</Option>
                  <Option value="申请科室">申请科室：</Option>
                </Select>
              )}
            >
              {getFieldDecorator("hospitalApply", { initialValue: "" })(
                this.state.hospitalDeptValue === "申请科室" ? (
                  <Select style={{ width: 304 }} showSearch optionFilterProp="label">
                    <Option value="">全部</Option>
                    {departmentList.map((item) => (
                      <Option key={item.DEPT_UID} value={item.DEPT_CODE} label={item.DEPT_NAME}>
                        {item.DEPT_NAME}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <Select style={{ width: 304 }} showSearch optionFilterProp="label">
                    <Option value="">全部</Option>
                    {applyHospitalList.map((item) => (
                      <Option
                        key={item.APPLY_HOSPITAL_CODE}
                        value={item.APPLY_HOSPITAL_CODE}
                        label={item.APPLY_HOSPITAL_NAME}
                      >
                        <Tooltip title={item.APPLY_HOSPITAL_NAME}>{item.APPLY_HOSPITAL_NAME}</Tooltip>
                      </Option>
                    ))}
                  </Select>
                )
              )}
            </Form.Item>
            <Form.Item
              label={getFieldDecorator("hospitalDateTime", {
                initialValue: (settingData && settingData.hospitalDateTime) || "创建日期",
              })(
                <Select>
                  <Option value="申请日期">创建日期：</Option>
                  <Option value="远程申请日期">申请会诊日期:</Option>
                  <Option value="检查日期">检查日期：</Option>
                  <Option value="报告日期">报告日期：</Option>
                  <Option value="完成会诊日期">完成会诊日期：</Option>
                </Select>
              )}
              className="mark dateTime"
            >
              {/* {getFieldDecorator("hospitalItemDateTime", {
                initialValue: [startDate, endDate],
              })(
                <RangePicker allowClear={false} disabledDate={this.disabledDate} />
              )} */}
              {getFieldDecorator("startTime", { initialValue: startDate })(
                <DatePicker
                  style={{ width: 125 }}
                  allowClear={false}
                  placeholder="开始日期"
                  disabledDate={this.disabledDate}
                />
              )}
              <span style={{ display: "inline-block", textAlign: "center", width: 15 }}>-</span>
              <Form.Item style={{ width: 110 }}>
                {getFieldDecorator("endTime", { initialValue: endDate })(
                  <DatePicker
                    style={{ width: 125 }}
                    allowClear={false}
                    placeholder="结束日期"
                    disabledDate={this.disabledDate}
                  />
                )}
              </Form.Item>
            </Form.Item>
            <Form.Item className="btn">
              <Button style={{ marginRight: "30px" }} onClick={this.searchListFn}>
                查 询
              </Button>
              <Button onClick={() => this.handleChangeReset()}>重 置</Button>
            </Form.Item>
            <div style={{ position: "absolute", left: "75%", top: "10%" }}>
              <Progress
                className="progress"
                type="circle"
                strokeColor="#009d96"
                width={80}
                percent={percent}
                format={(percent) => "自动刷新"}
              />
            </div>
          </div>
        </Form>
      </>
    );
  }
}

export default Form.create()(ConstQueryTable);
